import { render, staticRenderFns } from "./index.vue?vue&type=template&id=c163d27c&scoped=true"
import script from "./index.vue?vue&type=script&lang=js"
export * from "./index.vue?vue&type=script&lang=js"
import style0 from "./index.vue?vue&type=style&index=0&id=c163d27c&lang=scss&scoped=true"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "c163d27c",
  null
  
)

/* hot reload */
if (module.hot) {
  var api = require("/root/workspace/frontend_coduck_manage_sbGx/node_modules/vue-hot-reload-api/dist/index.js")
  api.install(require('vue'))
  if (api.compatible) {
    module.hot.accept()
    if (!api.isRecorded('c163d27c')) {
      api.createRecord('c163d27c', component.options)
    } else {
      api.reload('c163d27c', component.options)
    }
    module.hot.accept("./index.vue?vue&type=template&id=c163d27c&scoped=true", function () {
      api.rerender('c163d27c', {
        render: render,
        staticRenderFns: staticRenderFns
      })
    })
  }
}
component.options.__file = "src/components/senate/add-template/index.vue"
export default component.exports